import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { TourService } from '../../services/tour.service';

@Component({
  selector: 'calsoft-tour-overlay',
  templateUrl: './tour-overlay.component.html',
  styleUrls: ['./tour-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourOverlayComponent {

  readonly tourActive$: Observable<boolean> = this.tourService.tourActive$;

  constructor(private readonly tourService: TourService) {}

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.tourService.exitTour();
  }

  exit(): void {
    this.tourService.exitTour();
  }
}
